import { List,Map, Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { FlatRectRecord } from "../../helper/FlatRectRecord";

export const TimelineDisplayRecord = Record({
  sortedEventIds: List(),
  eventsById: Map(),
  // positions: Map(),
  groups: Map(),
  unitScale: 1.0,
  bounds: FlatRectRecord()
});

const data = {
  objects: {
    bounds: "FlatRectRecord",
    sortedEventIds: "List"
  },
  collections: {
    eventsById: "ItemDisplayRecord",
    // positions: "TimelineViewEventPositionRecord",
    groups: "TimelineViewGroupRecord"
  }
};
createFromJS.registerCallback("TimelineDisplayRecord", createFromJS.createNestedCallback(TimelineDisplayRecord, data));
